export const ADS = {
  PRINCIPAL_BANNER: "9681595155",
  VERTICAL_AD_1: "3396568036",
  VERTICAL_AD_2: "5132800467",
  PRADA: "6953158332",
  HORIZONTAL_AD: "8457323025",
};
